

<!DOCTYPE html>
<!--
This is a starter template page. Use this page to start your new project from
scratch. This page gets rid of all links and provides the needed markup only.
-->



<html lang="en">



  <style>
    
    .centerdiv {
      margin-left: auto;
      margin-right: auto;
      
      text-align: center;
      background-color: black;
  }.circulo{
    background-color: blue;
    width: 100px;
    height: 100px;
    }
    .backgroundDiv{
    text-align: center;
  opacity: 0.9;
  }.IconoWhatsApp{
  height: 0px;
}
img.whatsapp {
  position: fixed;
  width: 40px;
  bottom: 65px;
  right: 42px;
  color: #FFF;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  z-index: 100;
  display: none;
}
#appear.active{
  display:inline;
}
    </style>

<body>
  
<app-sidebar-ecomerce></app-sidebar-ecomerce>



<nav class="main-header navbar navbar-expand navbar-white navbar-light" style="height: 80px;" >
  <!-- Left navbar links -->


  <!-- Right navbar links -->
  <ul class="navbar-nav lg-auto"  >
   
      <li class="nav-item" *ngIf="ocultarCarrito == false" >
        <a class="nav-link" data-widget="pushmenu"   role="button" style="height: 50px;">
          <i class="fas fa-bars" style="font-size: 34px;color:rgba(7, 7, 7, 0.638);margin-top: -6px; height: 48px;width: auto;"></i>
        </a>
      </li>

    

    <!-- Navbar Search -->
    <li class="nav-item">
      <a class="nav-link" data-widget="navbar-search" role="button" (click)="OnHabilitarBusqueda()" *ngIf="ocultarCarrito == false"  style="width: 48px;height: 48px;" >
        <i class="fas fa-search"style="font-size: 32px; color:rgba(7, 7, 7, 0.638); margin-top: -6px; " ></i>
      </a>
      <div class="navbar-search-block" >
        <form class="form-inline"  [formGroup]="formBuscar" >
          <div class="input-group input-group-sm" >
            <input class="form-control form-control-navbar" type="text"  aria-label="Search" style="font-size: 20pt;height: 48px;border: 2px solid #0A0A0A; color: #0b0b0b;font-weight: bold;background-color: #FFFFFF;;height: 52px;" formControlName="txtBuscar" (keyup.enter)="OnBuscarAll()" >
            <div class="input-group-append">
              <button class="btn btn-navbar" type="button"  (click)="OnBuscarAll()"   style="border: 2px solid #424949;"  >
                <i class="fas fa-search" style="font-size: 36px;"></i>
              </button>
              <button class="btn btn-navbar" type="button" data-widget="navbar-search"  (click)="OnCerrarBusqueda()" style="border: 2px solid #424949;">
                <i class="fas fa-times" style="font-size: 36px;"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </li>

  

  </ul>
  
 
  
  <ul    class="navbar-nav ml-auto">
    <li  class="nav-item" >
  
      <div >
        <img src="./assets/dist/img/titulo_andrea.png"  width="150" height="35"  />
       </div>
 
    
    </li>  

  </ul>

  <ul    class="navbar-nav ml-auto">

    



    <li  class="nav-item dropdown" *ngIf="tieneSession == true" >

      <a class="nav-link" data-toggle="dropdown" href="#" *ngIf="ocultarCarrito == false">
   

          <img src="./assets/dist/img/user.png"  width="auto" height="42px" style="margin-top: -16px;margin-right: -12px;"  />

   
        
      </a>
      <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
        <a href="#" class="dropdown-item">
          <!-- Message Start -->
          <div class="media">
          
            <div class="media-body">
              <h3 class="dropdown-item-title">
                {{nombreCuenta}}
                <span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>
              </h3>
              
            </div>
          </div>
          <!-- Message End -->
        </a>
        <div class="dropdown-divider"></div>
        <a  class="dropdown-item" (click)="logout()">
          <!-- Message Start -->
          <div class="media">
           
            <div class="media-body">
              <h3 class="dropdown-item-title">
              Cerrar sesión
                <span class="float-right text-sm text-muted"><i class="fas fa-star"></i></span>
              </h3>
              
            </div>
          </div>
          <!-- Message End -->
        </a>
       
       
        
      </div>

    </li>

    <li  class="nav-item"    *ngIf="ocultarCarrito == false" style="margin-right: 8px;margin-top: -8px;">
      <a href="#/carrito">
      <img src="./assets/dist/img/carro.png"  width="auto" height="46"   />
      </a>
    </li>

    <span style="color: rgb(50, 50, 50);font-size: 35px;font-weight:bold">{{CantidadItem}}</span>


      <!-- <a  href="#/carrito">
        <img  src="./assets/dist/img/carro.png" width="auto" height="54px"  >
      
      </a> -->
    
  


<!-- <a class="btn btn-danger btn-lg" href="#/carrito" style="color:rgb(255, 255, 255); background-image: url('./assets/dist/img/carro.png');background-color: transparent;background-size: 100% 100%;border-color: transparent;width: 52px; height: 52px;font-size: x-large;text-align: right;margin: 6px">
{{countpedido}}   
 
</a> -->




   


   


  </ul>
 






</nav>


<!-- /.navbar -->


<div class="wrapper">

  <!-- Navbar -->
 

  <!-- /.navbar -->

  <div   #myModal class="modal fade" id="modal-default">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Andrea Store</h4>
          <button type="button"  class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{msjTiempoEtrega}}</p>
          <p>¿Está de acuerdo?</p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
          <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="OnGuardarPedido()">Sí, estoy de acuerdo.</button>
        </div>
      </div>
     
    </div>
   
  </div>
  <!-- /.modal -->

  <div class="modal fade" id="modal-imagen1">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="OnCerrarDialogo()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <img class="d-block w-100" src={{urlServerUpload$}}{{imagenDTO}}{{tipoMedia$}}  alt="First slide" > 
        </div>
        <div class="modal-footer justify-content-between">
         
         
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>



  <div class="modal fade" id="modal-imagen3">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <img class="d-block w-100" src={{urlServerUpload$}}{{imagenDTO3}}{{tipoMedia$}}  alt="First slide" > 
        </div>
        <div class="modal-footer justify-content-between">
         
         
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>








  <div  #myModalError class="modal fade" id="modal-sm" >
    <div class="modal-dialog modal-sm" >
      <div class="modal-content" >
        <div class="modal-header" style="border-color: black;">
          <h4 class="modal-title">www.andreagt.com</h4>
          <button type="button"  data-dismiss="modal" aria-label="Close" style="width: 48px;font-size: xx-large;border-style: none;background-color: transparent;" (click)="Mostrar1()">
            <span style="color: #000000;padding-top: 0.5em;
padding-bottom: 0.5em;font-size: 35px;">&times;</span>
          </button>
        </div>
        <div class="modal-body" >
         
          <br>
          <br>
       

          <blockquote class="quote-danger">
          <h4 id="note">Nota:</h4>
          <p style="font-size: x-large;">{{mensajeForm}}</p>
          </blockquote>
          <br>
          
          <br>
          
        </div>
        <div class="modal-footer justify-content-between" style="border-color: black;">
          <button type="button" class="btn btn-danger" data-dismiss="modal" style="font-size: x-large;" (click)="OnCerrarDialogo()">Cerrar</button>
        
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  

<br>


  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper" >
    <div id="targetInicio"></div>
    <section class="content"  id="#contenido0" >
      <div class="card card-success">
          
        <div class="centerdiv">
       
            <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" >
              <ol class="carousel-indicators" >
                <br>
                <br>
                <br>
                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active" ></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
               
              </ol>
              <div class="carousel-inner">
                <div class="carousel-item active" >
                  <div > <img  class="center" src="./assets/dist/img/carrusel1.jpg" width="100%" height="50%"   class="img-fluid"> </div>   
                  
                </div>
                <div class="carousel-item" >
                   <img  class="center" src="./assets/dist/img/carrusel2.jpg" width="100%" height="50%"  class="img-fluid"> 
                </div>
                <div class="carousel-item">
                   <img  class="center" src="./assets/dist/img/carrusel3.jpg" class="img-fluid" width="100%" height="50%"  > 
                </div>
              </div>
              <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev" style="width: 48px;">
                <span class="carousel-control-custom-icon" aria-hidden="true">
                  <i class="fas fa-chevron-left" style="font-size:20px;"></i>
                </span>
              
              </a>
              <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next" style="width: 48px;">
                <span class="carousel-control-custom-icon" aria-hidden="true">
                  <i class="fas fa-chevron-right" style="font-size:20px;"></i>
                </span>
              
              </a>
            </div>

          


         
        </div>
   

     
      </div>  


      <div class="card card-success">
    
     
        <video [autoplay]="true" [muted]="true" [loop]="true" [playsInline]="true" [controls]="true" width="100%" height="100%">
          <source [src]="'./assets/dist/img/andreabanner.mp4'" type="video/mp4" />
          
        </video>
    
      </div>
  
    </section>


    <!-- Main content -->
    <section class="content"  id="#contenido" >
 
      <div *ngIf="modoBusqueda== false">
      <form [formGroup]="formPedido">
       <!-- Default box -->
       <div class="card card-solid" >
        <div class="card-body"  style="background-color:rgb(255, 255, 255);">
          <div class="row" style="background-color:rgb(255, 255, 255);">
            <div class="col-12 col-sm-6" >
              <div id="carouselExampleIndicators2" class="carousel slide" data-ride="carousel"  >
                <ol class="carousel-indicators" >

                  <li data-target="#carouselExampleIndicators2" data-slide-to="0" class="active" style="background-color: rgb(27, 26, 26);"></li>
                  <li data-target="#carouselExampleIndicators2" data-slide-to="1" style="background-color: rgb(27, 26, 26);"></li>
                  <li data-target="#carouselExampleIndicators2" data-slide-to="2" style="background-color: rgb(27, 26, 26);"></li>
                </ol>
                <div class="carousel-inner" >
                  <div class="carousel-item active"  >
                
                    <img class="d-block w-100" src={{urlServerUpload$}}{{imagenDTO}}{{tipoMedia$}}  alt="First slide" data-toggle="modal" data-target="#modal-imagen1"> 
                  </div>
                  <div class="carousel-item">
                     <img class="d-block w-100" src={{urlServerUpload$}}{{imagenDTO2}}{{tipoMedia$}} alt="Second slide" data-toggle="modal" data-target="#modal-imagen2"> 
                  </div>
                  <div class="carousel-item">
                     <img class="d-block w-100" src={{urlServerUpload$}}{{imagenDTO3}}{{tipoMedia$}} alt="Third slide" data-toggle="modal" data-target="#modal-imagen3"> 
                  </div>
                </div>
                
                <a class="carousel-control-prev" href="#carouselExampleIndicators2" role="button" data-slide="prev" style="color: #343434;opacity: 0.9;">
                  <span class="carousel-control-custom-icon" aria-hidden="true"  style="color: #343434;">
                    <i class="fas fa-chevron-left" style="color: #343434;" ></i>
                  </span>
                </a>

                <a class="carousel-control-next" href="#carouselExampleIndicators2"  role="button" data-slide="next" style="color: #343434;opacity: 0.9;">
                  <span class="carousel-control-custom-icon" aria-hidden="true" style="color: #343434">
                    <i class="fas fa-chevron-right" style="color: #343434"></i>
                  </span>
               
                </a>

               

              </div>

              


            </div> 
            <div class="col-12 col-sm-6" >
              <h3 class="my-3" style="color:#d40606" >{{modeloDTO}}</h3>
              <p style="font-size: larger;">{{detallesDTO}}</p>

              <hr>

              <h4 class="mt-3"> {{alturaDTO}}<small></small></h4>

              <hr>

              <!-- <h4  style="color:rgb(204, 17, 17)">Color:</h4> -->

              <div class="small-box" style="height: 36px;text-align: center;background-color: #d40606" >
                <h4 style="font-weight:bold;font-size:x-large;color: #ffffff;">Color</h4>
                
              </div>

              
              <div class="form-group">

                <div class="row">
                  <div class="col-sm-10">
               





                   
                    <div class="custom-control custom-radio" *ngFor="let dato of colorERP; let i=index">
                      <div >

                        <input class="custom-control-input custom-control-input-danger" type="radio" id={{dato.colorId}} name="customRadio" (change)="OnSelectColorERP(dato.colorId,dato.color)" style="height: 48px;width: 48px;" >
                        <label for={{dato.colorId}} class="custom-control-label text-bold" style="color:rgb(30, 29, 29);font-size: 25px;">{{dato.color}}</label>
                      </div>
                      <br>
                     
                    </div>

                    


                    <!-- <div class="custom-control custom-radio" *ngFor="let dato of colorERP; let i=index">
                      <div >

                        <input class="custom-control-input custom-control-input-danger" type="radio" id={{dato.colorId}} name="customRadio" (change)="OnSelectColorERP(dato.colorId,dato.color)"  >
                        <label for={{dato.colorId}} class="custom-control-label text-lg" style="color:rgb(17, 16, 16);">{{dato.color}}</label>
                      </div>
                      <br>
                     
                    </div> -->



                      <!-- <select class="form-control" formControlName="cmbColor" (change)="OnSelectColorERP()" style="height:48px;font-size: 24px;" >


                        <option *ngFor="let dato of colorERP; let i=index" value={{dato.colorId}},{{dato.color}}>{{dato.color}}</option>
                    
                        
                     
                      </select> -->

                  
                    


            </div>
          </div>

            

             
            </div>

            <div class="small-box " style="height: 36px;text-align: center;background-color: #d40606" >
              <h4 style="font-weight:bold;font-size:x-large;color: #ffffff;">Talla</h4>
              
            </div>


          
              <div class="form-group">
                <div class="row">
                  <div class="col-sm-10">
               

                    <!-- <div class="icheck-success d-inline" *ngFor="let dato of stock; let i=index">
                     
                        <input type="radio" name="customRadio2"   id={{dato.indice}} (change)="OnSelectTalla(dato.idTalla,dato.nMx,dato.talla)">
                        <label for={{dato.indice}}   style="font-size: 21px;color:rgb(0, 0, 0);">{{dato.talla}} 
                        </label>
                     
            
                      <br>
                      <br>
                     
                    </div> -->




                    <div class="custom-control custom-radio" *ngFor="let dato of stock; let i=index">
                      <div >

                        <input class="custom-control-input custom-control-input-danger"  type="radio" id={{dato.indice}} name="customRadio2" (change)="OnSelectTalla(dato.idTalla,dato.nMx,dato.talla) " style="height: 48px;width: 48px;"  >
                        <label for={{dato.indice}} class="custom-control-label text-bold" style="color:rgb(30, 29, 29);font-size: 25px;">{{dato.talla}}</label>
                      </div>
                      <br>
                     
                    </div>

                
                    


                    <!-- <select class="form-control" formControlName="cmbTalla" (change)="OnSelectTalla()" style="height:48px;font-size: 24px;" >


                      <option *ngFor="let dato of stock; let i=index" value={{dato.idTalla}},{{dato.nMx}},{{dato.talla}}>{{dato.talla}}</option>
                  
                      
                   
                    </select> -->
                    

                  
                    


            </div>
          </div>
                
        
          
            
            </div>

            <div *ngIf="descuentoDTO >0 && precioDTO >0  ">
            <div class="bg-warning py-2 px-3 mt-4">
              <h4 class="mb-0" >
                <del> Antes: Q.{{precioDTO}}</del>
              
              </h4>
              
            </div>
          </div>
              
              <div class=" py-2 px-3 mt-4" style="background-color: #ffe100;" *ngIf="ocultar == false">
                <h2 class="mb-0" style="font-size: xx-large;font-weight:bold">
                 Ahora: Q.{{precioFinalDTO}}
                </h2>
                
              </div>

              <h4 class="mt-3" *ngIf="ocultar == false">Cantidad </h4>
              <div class="col-sm-8" *ngIf="ocultar == false">
              <div class="mt-3">
                <select class="custom-select form-control-border" formControlName="cmbCantidad"  style="font-size:x-large; height: auto;">
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                </select>

              </div>
            </div>
             
            <div class="card-body box-profile" *ngIf="ocultar == false">
              <div class="text-center">
                <div class="btn btn-danger btn-lg btn-flat" style="height: 55px;font-weight:bold;font-size: 24px;color: #ffffff;background-color: #d40606;"  (click)="OnAbrirDialogo()">
                  <i class="fas fa-cart-plus fa-lg mr-3" style="font-weight:bold;font-size: 24px;"></i>
                  Agregar a carrito
               

                
              </div>
              </div>




              
            </div>

          

            <div class="card-body box-profile" *ngIf="ocultar == false">
              <div class="text-center">
                <div class="btn btn-primary btn-lg btn-flat" style="height: 55px;font-weight:bold;font-size: 26;color: #ffffff;" (click)="OnRegresarInicio()">
                
                  Otro Producto 
               
              </div>
              </div>
            </div>
            </div>
          </div>
   

      <div *ngIf="mostrarRelacionados == true">

          <div class="content-header">
            <div class="container" style="text-align: center;">
              <div class="row mb-2">
                <div class="col-sm-12">
                  <h1 class="m-0">¡Tambíen te recomendamos...!<small></small></h1>
                </div><!-- /.col -->
                
              </div><!-- /.row -->
            </div><!-- /.container-fluid -->
          </div>
          
              
                <div class="row">
                  <div class="card card-success">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6 col-sm-6 col-md-4 align-items-stretch " *ngFor="let datos of productosRel; let i=index" >
                         
                            
                            <div class="card-body pt-0"  (click)="OnSelectProducto(datos.idProducto)">
                              <div class="row">
        
                                <!-- <div style="height: 50%;width: 50%;background-size:cover;background-position:center; background-repeat:no-repeat;background-image: url('{{urlServerUpload$}}{{datos.ima}}{{tipoMedia$}}')" >
                                </div> -->
                                <div class="text-center">
                         
                                  <img class="img-fluid"
                                       src={{urlServerUpload$}}{{datos.imagen}}{{tipoMedia$}}
                                       alt="User profile picture" style="height: 110%;width: 110%;">
                                </div>
        
                                <div class="col-8">
        
                                  <label class="text-muted text-sm">{{datos.modelo}}</label><br>
                                  <label class="text-muted text-sm">{{datos.descripcion}}</label>
                                
                                 
                                </div>
                                <div class="col-8" >
                                  <p class="text-muted " style="font-size: 16px;color: rgb(20, 20, 20);"><b>{{datos.precio | currency: 'Q'}}</b> </p>
                                
                               
                               </div>
                                
                                
                             
                              </div>
                             
                                
                            </div>
                            
                      
                        </div>
        
        
        
                        
                     
        
                      </div>
                    </div>
        
              
                
        
                      </div>
        


          </div>
       
  </div>



            
         
        </div>
        <!-- /.card-body -->
      </div>
    </form>
  </div>

  
  <div *ngIf="modoBusqueda== true ">

    <div class="card-body">
      <div class="row">

        

        <div class="card card-success">
          <div class="card-body">
          
            <div class="row"   infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="50"
            (scrolled)="onScroll()">
             

        
                <div class="col-6 col-sm-6 col-md-4 align-items-stretch " *ngFor="let datos  of content" >
                  <div class="card-body pt-0"  (click)="OnSelectProducto(datos.idProducto)">
                    <div class="row">
                     
                      <div class="text-center">
                        <img class="img-fluid"
                        src={{urlServerUpload$}}{{datos.imagen}}{{tipoMedia$}}
                             alt="User profile picture" style="height: 110%;width: 110%;">
                      </div>
                      <div class="col-8">
                        <label class="text-muted text-sm">{{datos.modelo}}</label><br>
                        <label class="text-muted text-sm">{{datos.descripcion}}</label>
                       
                      </div>
                      <div class="col-8" >

                    
                          <p class="text-muted " style="font-size: 16px;color: rgb(30, 30, 30);"><b>{{datos.precio | currency: 'Q'}}</b> </p>
             

                     </div>
                    </div>
                  </div>
                </div>
    
             
                
          
            </div>

            </div>

    
      

            </div>
 
  </div>
  </div>
  </div>






    </section>
    <!-- /.content -->
    <div class="content">
      <div class="container">
        <div class="row">

          <div class="card card-success">
            <div class="card-body">
              
                <div class="col-12 col-sm-12" >

          <app-footer-sucursal-ecomerce></app-footer-sucursal-ecomerce>
        </div>
     
    </div>
  </div>
</div>
      </div>
    </div>


    <div class="IconoWhatsApp">
      <a
      href="https://wa.me/+50243185405?text=mensaje"
      target="_blank">
      <img id="appear"
        class="whatsapp"
        src="./assets/dist/img/whatsapp.png"
        alt="IconoWhatsApp"
      />
    </a>
  </div>
  
  </div>
  <!-- /.content-wrapper -->

  <!-- Control Sidebar -->
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->

  </aside>
  <!-- /.control-sidebar -->


 

</div>
  <!-- Main Footer -->
<app-footer-ecomerce></app-footer-ecomerce>

<!-- SweetAlert2 -->



</body>

</html>
